import React from 'react';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import moment from 'moment';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, Button, FormControl } from 'react-bootstrap';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';

import Link from '../../../Link';
import CustomPagination from '../../../CustomPagination';
import CurrencyConverter from '../../../CurrencyConverter';

import { deletePromoCode } from '../../../../actions/siteadmin/PromoCode/deletePromoCode';
import { addPromoCode } from '../../../../actions/siteadmin/PromoCode/addPromoCode';
import getAllPromoCode from './getAllPromoCode.graphql';
import { withQuery } from '../../../../hoc/withGraphql';
import debounce from '../../../../helpers/debounce';
import messages from '../../../../locale/messages';

import { CommonAdminEditIcon, CommonAdminTrashIcon } from '../../../Common/Assets/SVGIcon/CommonSvgIcon';
import { demoRestrictionEncode } from '../../../../actions/demoRestriction';

import bt from '../../../../components/commonStyle.css';
import s from './PromoCodeList.css';

class PromoCodeList extends React.Component {

  constructor(props) {
    super(props)
    this.state = { currentPage: 1, searchList: '', isRestrict: false };
    this.paginationData = this.paginationData.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeywordSearch = debounce(this.handleKeywordSearch.bind(this), 250);
  }


  async componentDidMount() {
    const { demoRestrictionEncode } = this.props;
    const isRestrict = await demoRestrictionEncode({});
    this.setState({ isRestrict });
  }


  handleKeywordSearch(searchList) {
    const { promoCodes: { refetch } } = this.props
    let variables = { currentPage: 1, searchList };
    this.setState(variables)
    refetch(variables)
  }

  async handleChange(e, id, title, description, code, type, promoValue, imageName, expiryDate) {
    const { addPromoCode, promoCodes: { refetch } } = this.props;
    const { isRestrict } = this.state;
    let data = {};
    data = {
      id: id,
      title: title,
      description: description,
      code: code,
      type: type,
      promoValue: promoValue,
      isEnable: e.target.value === 'active' ? "true" : "false",
      imageName,
      expiryDate: expiryDate ? moment(Number(expiryDate)).format('YYYY-MM-DD HH:mm:ss') : null,
      isRestrict
    }
    this.setState({ currentPage: 1 });
    let variables = { currentPage: 1 };
    await addPromoCode(data);
    refetch(variables);
  }

  async handleDelete(id, currentPage) {
    const { deletePromoCode, promoCodes: { refetch } } = this.props;
    let variables = { currentPage };
    await deletePromoCode(id);
    refetch(variables);
  }

  paginationData(currentPage) {
    const { promoCodes: { refetch } } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage });
    refetch(variables);
  }

  render() {
    const { promoCodes, intl: { formatMessage } } = this.props;
    const { currentPage } = this.state;
    return (
      <div className={'whiteDropdown'}>
        <div className={s.exportDisplay}>
          <div className={s.searchGroupContainer}>
            <div className={cx(s.searchInput, 'searchInputRTL')}>
              <FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(e) => this.handleKeywordSearch(e.target && e.target.value)} className={bt.formControlInput} />
            </div>
          </div>
          <div className={cx(s.exportTextSection)}>
            <Link to={'/siteadmin/promo-code/add'} className={cx(bt.btnPrimary, bt.displayInlineBlock)} ><FormattedMessage {...messages.addPromoCode} /></Link>
          </div>
        </div>
        <div className='tableOuterContainer'>
          <Table className="tableContainer">
            <thead>
              <tr>
                <th scope="col"><FormattedMessage {...messages.id} /></th>
                <th scope="col"><FormattedMessage {...messages.code} /></th>
                <th scope="col"><FormattedMessage {...messages.title} /></th>
                <th scope="col"><FormattedMessage {...messages.discount} /></th>
                <th scope="col"><FormattedMessage {...messages.status} /></th>
                <th scope="col"><FormattedMessage {...messages.action} /></th>
                <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
              </tr>
            </thead>
            <tbody>
              {
                promoCodes && promoCodes.getAllPromoCode && promoCodes.getAllPromoCode.results && promoCodes.getAllPromoCode.results.length > 0 && promoCodes.getAllPromoCode.results.map((item, index) => {
                  let status = item.isEnable ? 'active' : 'inactive';
                  return (
                    <tr key={index}>
                      <td data-label={formatMessage(messages.id)}>{item && item.id}</td>
                      <td data-label={formatMessage(messages.code)}>{item && item.code}</td>
                      <td data-label={formatMessage(messages.title)}>{item && item.title}</td>
                      <td data-label={formatMessage(messages.discount)}>
                        {
                          item && item.type === 1 && <span>
                            {item.promoValue + '%'}
                          </span>
                        }
                        {
                          item && item.type !== 1 && <CurrencyConverter
                            amount={item.promoValue}
                            from={item.currency}
                          />
                        }
                      </td>
                      <td data-label={formatMessage(messages.status)}>
                        <div>
                          <select name="isEnable" onChange={(e) => this.handleChange(e, item.id, item.title, item.description, item.code, item.type, item.promoValue, item.imageName, item.expiryDate)} className={bt.selectInput} value={status}>
                            <option value="active">{formatMessage(messages.active)}</option>
                            <option value="inactive">{formatMessage(messages.inactive)}</option>s
                          </select>
                        </div>
                      </td>
                      <td data-label={formatMessage(messages.action)}>
                        <div>
                          <Link to={'/siteadmin/promo-code/edit/' + item.id} className={s.noLink}>
                            <CommonAdminEditIcon className={cx(s.editIcon, 'editIconRTL')} />
                            <span className={s.vtrMiddle}>
                              <FormattedMessage {...messages.editAction} />
                            </span>
                          </Link>
                        </div>
                      </td>
                      <td data-label={formatMessage(messages.deleteAction)} >
                        <div>
                          <Button onClick={() => this.handleDelete(item.id, currentPage)} className={s.iconBtn}>
                            <CommonAdminTrashIcon className={cx(s.editIcon, 'editIconRTL')} />
                            <span className={s.vtrMiddle}>
                              <FormattedMessage {...messages.deleteAction} />
                            </span>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  )
                })
              }
              {
                promoCodes && promoCodes.getAllPromoCode && promoCodes.getAllPromoCode.results && promoCodes.getAllPromoCode.results.length == 0 && (
                  <tr>
                    <td colspan="12" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
                  </tr>
                )
              }
            </tbody>
          </Table>
        </div>
        {
          promoCodes && promoCodes.getAllPromoCode && promoCodes.getAllPromoCode.count > 0 && <div className={cx(bt.space5, bt.spaceTop5)}>
            <CustomPagination
              total={promoCodes.getAllPromoCode.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.promoCodeId)}
            />
          </div>
        }
      </div>
    );
  }
}

const mapState = (state) => ({});
const mapDispatch = {
  deletePromoCode,
  addPromoCode,
  demoRestrictionEncode
};

export default compose(injectIntl,
  withStyles(bt, s),
  withQuery(getAllPromoCode, {
    name: 'promoCodes',
    options: {
      variables: {
        currentPage: 1,
        searchList: ''
      },
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }),
  connect(mapState, mapDispatch)
)(PromoCodeList);
